import { useTranslation } from 'react-i18next';

export const useEiaConsultationStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('eia_consultation_stats_annual_dfi_report');

  const eiaConsultationStatsLabels: Record<string, string> = {
    totalEiaConsultationsReceived: t(
      'total_eia_consultations_received',
      'Total number of EIA consultations received'
    ),
    averageDaysTakenToRespondToEiaConsultations: t(
      'average_days_taken_to_respond_to_eia_consultations',
      'Average number of days taken to respond to EIA consultations'
    ),
  };

  return eiaConsultationStatsLabels;
};
